import React from 'react';
import ArrowIcon from 'mdi-react/ChevronRightIcon';

import { Banner, CampaignLink, LinkText, Text } from './styles';
import { Campaign, CampaignBanner } from '../../../types';

type Props = {
  banners: Banner[];
  className: string;
  inverted: boolean;
};

type Banner = Pick<CampaignBanner, 'options'> & {
  campaign: Pick<Campaign, 'media'>;
};

const PromoBanner = ({ banners, className, inverted }: Props) => {
  // TODO: render banner based on priority
  const activeBanner = banners[0];
  const options = activeBanner.options || {};

  const tagline = (options.tagline && options.tagline.text) || '';
  const path = options.customLink && options.customLink.url;
  const linkText = (options.customLink && options.customLink.text) || '';
  const color = options.fallbackColor || '#000';
  const logo =
    (activeBanner.campaign &&
      activeBanner.campaign.media &&
      activeBanner.campaign.media.images &&
      activeBanner.campaign.media.images.icon) ||
    undefined;

  if (!path) {
    return null;
  }

  return (
    <Banner
      className={className}
      to={path}
      logo={logo}
      themeColor={color}
      inverted={inverted}
    >
      <Text inverted={inverted} themeColor={color}>
        {tagline}
      </Text>

      <CampaignLink themeColor={color} inverted={inverted}>
        {linkText && <LinkText>{linkText}</LinkText>}
        <ArrowIcon />
      </CampaignLink>
    </Banner>
  );
};

export default PromoBanner;
